import React from "react";
import pathUtils from "path";
import { Switch, Route, Link } from "react-router-dom";

import { isArray } from "2g-utils-common";
import PageHeading from "2g-page-heading";
import { childrenType } from "2g-types";

import AutocompletesExample from "./autocompletes/AutocompletesExample";
import FormSwitchesExample from "./form-switches/FormSwitchesExample";
import KonfiguracniParametryEditaceExample from "./konfiguracni-parametry-editace/KonfiguracniParametryEditaceExample";
import NotifikaceExample from "./notifikace/NotifikaceExample";
import LoginFormExample from "./LoginFormExample";
import FixniNarokyNasledujiciExample from "./fixni-naroky-nasledujici/FixniNarokyNasledujiciExample";
import FixniPozadavkyBoxExample from "./fixni-pozadavky-box/FixniPozadavkyBoxExample";
import FixniPozadavkyBoxContentExample from "./fixni-pozadavky-box/FixniPozadavkyBoxContentExample";
import FixniPozadavkyBoxErrorContentExample from "./fixni-pozadavky-box/FixniPozadavkyBoxErrorContentExample";
import PrilohyExample from "./prilohy/PrilohyExample";
import ProvozniInformaceCardsExample from "./provozni-informace-cards/ProvozniInformaceCardsExample";
import ProvozniInformaceDetailWidgetExample from "./provozni-informace-detail-widget/ProvozniInformaceDetailWidgetExample";
import ProvozniInformaceEditaceWidgetExample from "./provozni-informace-editace-widget/ProvozniInformaceEditaceWidgetExample";
import ProvozniInformaceFormExample from "./provozni-informace-form/ProvozniInformaceFormExample";
import ProvozniInformacePosledniWidgetExample from "./provozni-informace-posledni-widget/ProvozniInformacePosledniWidgetExample";
import ProvozniInformaceSearchExample from "./provozni-informace-search/ProvozniInformaceSearchExample";
import ProvozniInformaceWidgetExample from "./provozni-informace-widget/ProvozniInformaceWidgetExample";
import RenderersExample from "./renderers/RenderersExample";
import RenderersCiselnikExample from "./renderers/RenderersCiselnikExample";
import RezervaceTableExample from "./rezervace-table/RezervaceTableExample";
import RezervaceTableContentExample from "./rezervace-table/RezervaceTableContentExample";
import RezervaceTabsExample from "./rezervace-tabs/RezervaceTabsExample";
import RezervaceWidgetExample from "./rezervace-widget/RezervaceWidgetExample";
import TextComponentExample from "./text-component/TextComponentExample";
import ZadostiGroupsExample from "./zadosti-groups/ZadostiGroupsExample";
import ZadostiGroupsContentExample from "./zadosti-groups/ZadostiGroupsContentExample";
import ZadostiOdbaveniWidgetExample from "./zadosti-odbaveni-widget/ZadostiOdbaveniWidgetExample";
import ZadostiOdsouhlaseneTableExample from "./zadosti-odsouhlasene-table/ZadostiOdsouhlaseneTableExample";
import ZadostiOdsouhlaseneWidgetExample from "./zadosti-odsouhlasene-widget/ZadostiOdsouhlaseneWidgetExample";
import ZadostiRowDetailExample from "./zadosti-row-detail/ZadostiRowDetailExample";
import ZdrojeTabsExample from "./zdroje-tabs/ZdrojeTabsExample";
import ZdrojeTabsContentExample from "./zdroje-tabs/ZdrojeTabsContentExample";

export const BASE_PATH =
  window.initialProps && window.initialProps.BASE_PATH
    ? window.initialProps.BASE_PATH
    : "/";

const examples = [
  ["Autocompletes", "/autocompletes", AutocompletesExample],
  ["FormSwitches", "/form-switches", FormSwitchesExample],
  [
    "KonfiguracniParametryEditace",
    "/konfiguracni-parametry",
    KonfiguracniParametryEditaceExample
  ],
  ["Notifikace", "/notifikace", NotifikaceExample],
  ["LoginForm", "/login-form", LoginFormExample],
  [
    "FixniNarokyNasledujici",
    "/fixni-naroky-nasledujici",
    FixniNarokyNasledujiciExample
  ],
  [
    "FixniPozadavkyBox",
    "/fixni-pozadavky-box",
    [
      ["FixniPozadavkyBox", "example", FixniPozadavkyBoxExample],
      ["FixniPozadavkyBoxContent", "content", FixniPozadavkyBoxContentExample],
      [
        "FixniPozadavkyBoxErrorContentExample",
        "errorContent",
        FixniPozadavkyBoxErrorContentExample
      ]
    ]
  ],
  ["Prilohy", "/prilohy", PrilohyExample],
  [
    "ProvozniInformaceCards",
    "/provozni-informace-cards",
    ProvozniInformaceCardsExample
  ],
  [
    "ProvozniInformaceDetailWidget",
    "/provozni-informace-detail-widget",
    ProvozniInformaceDetailWidgetExample
  ],
  [
    "ProvozniInformaceEditaceWidget",
    "/provozni-informace-editace-widget",
    ProvozniInformaceEditaceWidgetExample
  ],
  [
    "ProvozniInformaceForm",
    "/provozni-informace-form",
    ProvozniInformaceFormExample
  ],
  [
    "ProvozniInformacePosledniWidget",
    "/provozni-informace-posledni-widget",
    ProvozniInformacePosledniWidgetExample
  ],
  [
    "ProvozniInformaceWidget",
    "/provozni-informace-widget",
    ProvozniInformaceWidgetExample
  ],
  [
    "ProvozniInformaceSearch",
    "/provozni-informace-search",
    ProvozniInformaceSearchExample
  ],
  [
    "Renderers",
    "/renderers",
    [
      ["Ciselnik", "ciselnik", RenderersCiselnikExample],
      ["Ostatni", "ostatni", RenderersExample]
    ]
  ],
  [
    "RezervaceTable",
    "/rezervace-table",
    [
      ["RezervaceTable", "example", RezervaceTableExample],
      ["RezervaceTableContent", "content", RezervaceTableContentExample]
    ]
  ],
  ["RezervaceTabs", "/rezervace-tabs", RezervaceTabsExample],
  ["RezervaceWidget", "/rezervace-widget", RezervaceWidgetExample],
  ["TextComponent", "/text-component", TextComponentExample],
  [
    "ZadostiGroups",
    "/zadosti-groups",
    [
      ["ZadostiGroups", "example", ZadostiGroupsExample],
      ["ZadostiGroupsContent", "content", ZadostiGroupsContentExample]
    ]
  ],
  [
    "ZadostiOdbaveniWidget",
    "/zadosti-odbaveni-widget",
    ZadostiOdbaveniWidgetExample
  ],
  [
    "ZadostiOdsouhlaseneTable",
    "/zadosti-odsouhlasene-table",
    ZadostiOdsouhlaseneTableExample
  ],
  ["ZadostiRowDetail", "/zadosti-row-detail", ZadostiRowDetailExample],
  [
    "ZadostiOdsouhlaseneWidget",
    "/zadosti-odsouhlasene-widget",
    ZadostiOdsouhlaseneWidgetExample
  ],
  [
    "ZdrojeTabs",
    "/zdroje-tabs",
    [
      ["ZdrojeTabs", "example", ZdrojeTabsExample],
      ["ZdrojeTabsContent", "content", ZdrojeTabsContentExample]
    ]
  ]
];

const ExamplesMenu = ({ examples, basePath }) => {
  return examples.map(([label, path, Component], index) => {
    return isArray(Component) ? (
      <li key={index}>
        {label}
        <ul>
          <ExamplesMenu
            examples={Component}
            basePath={pathUtils.join(basePath, path)}
          />
        </ul>
      </li>
    ) : (
      <li key={index}>
        <Link to={pathUtils.join(BASE_PATH, basePath, path)}>{label}</Link>
      </li>
    );
  });
};

const ExamplesRoutes = ({ examples, basePath }) => {
  return examples.map(([label, path, Component, options], index) => {
    return isArray(Component) ? (
      <ExamplesRoutes
        key={index}
        examples={Component}
        basePath={pathUtils.join(basePath, path)}
      />
    ) : (
      <Route
        key={index}
        {...options}
        path={pathUtils.join(BASE_PATH, basePath, path)}
      >
        <Component />
      </Route>
    );
  });
};

export function ComponentsExample({ children }) {
  return (
    <div className="b2b-ComponentsExample">
      <PageHeading>Komponenty aplikace</PageHeading>
      <div className="b2b-ComponentsExample-container">
        <ul className="b2b-ComponentsExample-navigation">
          <ExamplesMenu examples={examples} basePath="/components" />
        </ul>

        <div className="b2b-ComponentsExample-content">
          <Switch>
            <ExamplesRoutes examples={examples} basePath="/components" />
          </Switch>
        </div>
      </div>
    </div>
  );
}

ComponentsExample.propTypes = {
  children: childrenType
};

export default React.memo(ComponentsExample);
